import { render, staticRenderFns } from "./WorkerAddNew.vue?vue&type=template&id=263adf73&"
import script from "./WorkerAddNew.vue?vue&type=script&lang=js&"
export * from "./WorkerAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports